import React, { useState, useCallback } from "react";
import useSWR from "swr";
import { Link, useNavigate, useParams } from "react-router-dom";
import Button from "devextreme-react/button";
import ChatBox from "../../Components/ChatBox";
import LoadingSpinnerModal from "../../Components/LoadingSpinnerModal";
import ActionNotifications from "../../Components/ActionNotifications";
import ErrorMessage from "../../Components/ErrorMessage";
import { apiBaseURL } from "../../Utils/ProjectConstants";
import useFetch from "../../Hooks/useFetch";
import ProgressBar from "./Components/progressBar";
import InfoTab from "./Components/infoTab";
import { getUsersWorkCenter, checkRoles, getUserId } from "../../Utils/helper";
import { statusRender, urgencyRender } from "./variables.js";
import "./styles.css";
import DenyPurchaseOrders from "../../Components/DenyOrders/denyPurchaseOrders";
import ActionNeededPurchaseOrders from "../../Components/ActionNeededPO/index.js";
import ActionProvidedPurchaseOrders from "../../Components/ActionProvidedPO/index.js";

export default function PODetailsPage() {
  const navigate = useNavigate(),
    params = useParams(),
    fetch = useFetch(navigate),
    {
      data: orderData,
      mutate,
      error,
    } = useSWR(`${apiBaseURL}/api/PurchaseOrder?id=${params.POId}`),
    order = orderData?.data,
    name = order?.requestor?.name,
    [response, setResponse] = useState([]),
    isUserKristen = getUserId() === "d4ec0560-d7b0-4385-81a3-ef5ac53df4da";

  const setNotifications = (payload) => setResponse(payload);

  console.log("data", order);
  console.log("poStatus:", order?.poStatus);
  const fetchSuccessful = (response) => {
    setResponse(response);
    return (
      response?.success &&
      response?.data?.statusCode &&
      response?.success !== "Invalid Model"
    );
  };
  const [showPopup, setPopup] = useState({
    poActionNeeded: null,
    poActionProvided: null,
  });

  const handleClose = (popupKey) => {
    setPopup((prevState) => ({
      ...prevState,
      [popupKey]: null,
    }));
  };
  const handlePopup = useCallback((popupKey, data) => {
    console.log("handlePopup data", data);
    setPopup((prevState) => ({
      ...prevState,
      [popupKey]: { data },
    }));
  }, []);

  const renderGrid = () => {
    const date = new Date(order.requestedDate).toLocaleString("en-US");

    const onRowRemoved = async (e) => {
      //const response = await fetch.delete(`${apiBaseURL}/api/Orders?id=${params.orderId}`);
      const body = {
        id: e.key,
        poStatus: 7,
      };
      const response = await fetch.put(
        `${apiBaseURL}/api/PurchaseOrders`,
        body,
      );

      if (fetchSuccessful(response)) {
        mutate();
      }
    };
    return (
      <>
        {showPopup.poActionNeeded && (
          <ActionNeededPurchaseOrders
            orderId={showPopup.poActionNeeded.data}
            setNotifications={(n) => setResponse(n)}
            onClose={() => handleClose("poActionNeeded")}
            mutate={params?.mutate}
            fetch={fetch}
          />
        )}
        {showPopup.poActionProvided && (
          <ActionProvidedPurchaseOrders
            orderId={showPopup.poActionProvided.data}
            setNotifications={(n) => setResponse(n)}
            onClose={() => handleClose("poActionProvided")}
            mutate={params?.mutate}
            fetch={fetch}
          />
        )}

        <div className="px-4">
          <div className="title-container row justify-content-between">
            <div className="col-auto me-auto white">
              <div className="order-name">{`PO Request ${params.POId}`}</div>
              <div>{`Requested by ${name} on ${date}`}</div>
            </div>
            <Button
              className="col-auto"
              width={10}
              icon="trash"
              type="normal"
              stylingMode="text"
              visible={order.poStatus !== 5 && order.poStatus !== 7}
              onClick={onRowRemoved}
            />
            <Button
              style={{ margin: "0 10px" }}
              className="col-auto"
              type="normal"
              text="Request Action"
              stylingMode="contained"
              onClick={() => handlePopup("poActionNeeded", params.POId)}
              visible={
                (order?.poStatus < 4 || order?.poStatus === 11) &&
                order?.poStatus !== 10 &&
                isUserKristen
              }
            />
            <Button
              style={{ margin: "0 10px" }}
              className="col-auto"
              type="normal"
              text="Send For review"
              stylingMode="contained"
              onClick={() => handlePopup("poActionProvided", params.POId)}
              visible={order?.poStatus === 10}
            />
          </div>

          <div className="stats white">
            <div>
              <div className="sub-title">Urgency</div>
              <div className="stat-value">
                {urgencyRender(order.deadlineType)}
              </div>
            </div>
            <div>
              <div className="sub-title">Status</div>
              <div className="stat-value">{statusRender(order.poStatus)}</div>
            </div>
          </div>

          <ProgressBar
            type="PO"
            order={order}
            fetch={fetch}
            fetchSuccessful={fetchSuccessful}
            mutate={mutate}
          />

          <InfoTab
            poDetail={order}
            isUserKristen={isUserKristen}
            fetchSuccessful={fetchSuccessful}
            mutate={mutate}
          />
        </div>
      </>
    );
  };

  if (!orderData) {
    return <LoadingSpinnerModal show />;
  }
  return (
    <div className="px-lg-4 content">
      <ActionNotifications response={response} />
      <ChatBox
        id={params.POId}
        getURL={`/api/PurchaseOrder/Comments?orderId=${params.POId}`}
        postURL={"/api/PurchaseOrder/Comments"}
      />
      <div className="px-4 page-content">
        <div id="link">
          <Link className="hoverLinkText gray" to="/purchaseOrders" end>
            {/* &#x2190; code for the arrow */}
            <h5 className="mb-3 white">&#x2190; All POs</h5>
          </Link>
        </div>
        <div className="contentBox mb-3">
          {!error ? renderGrid() : <ErrorMessage />}
        </div>
      </div>
    </div>
  );
}
